import { Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';

import { colors } from 'styles/globalStyles';

const statusToColorsMap: { [key: string]: string } = {
  Success: colors.green,
  Error: colors.importRecordErrorStatus,
  'In progress': colors.orange,
  'Awaiting confirmation': colors.blue,
};

export const cellStyles = {
  textOverflow: 'ellipsis' as const,
  overflow: 'hidden' as const,
  whiteSpace: 'nowrap' as const,
};

export const StyledLink = styled(Link)(() => ({
  color: 'inherit',
  textDecoration: 'none',
  textTransform: 'capitalize',
}));

export const StyledStatusLabel = styled('div')(({ status }: { status: string }) => ({
  minHeight: '20px',
  minWidth: '82px',
  width: 'fit-content',
  paddingTop: '3px',
  paddingBottom: '3px',
  paddingLeft: '8px',
  paddingRight: '8px',
  marginRight: 'auto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '14px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: colors.white,
  borderRadius: '12px',
  backgroundColor: statusToColorsMap[status] ?? colors.importRecordDeletedStatus,
}));
